import { render, staticRenderFns } from "./Acompanhamento.vue?vue&type=template&id=50bbaf40&scoped=true"
import script from "./Acompanhamento.vue?vue&type=script&lang=js"
export * from "./Acompanhamento.vue?vue&type=script&lang=js"
import style0 from "./Acompanhamento.vue?vue&type=style&index=0&id=50bbaf40&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbaf40",
  null
  
)

export default component.exports